import React from 'react';
import AppRoutes from './AppRoutes';

function AppContent() {
  return <AppRoutes />;
}

export default AppContent;